import api from './axiosConfig';
import CustomEventDispatcher from './CustomEventDispatcher';

class PdfParsingService extends CustomEventDispatcher {

  constructor() {
    super()
    this.response = {};
  }

  async uploadPdf(file) {
    try {
      const formData = new FormData();
      formData.append('file', file);

      // De upload plaatst de PDF alleen in de wachtrij (snel); de parse gebeurt asynchroon
      // op de server. Geen lange timeout meer nodig.
      const response = await api.post('/api/pdf-parsing', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      const parsedData = response.data;

      const event = new CustomEvent('pdfQueued', {
        detail: {
          filename: file.name,
          data: parsedData,
          success: true
        }
      });

      setTimeout(() => {
        this.dispatchEvent(event);
      }, 100);

      return { success: true, data: parsedData, filename: file.name };
    } catch (error) {
      console.error('Er is een fout opgetreden in uploadPdf():', error);

      let errorMessage = error.response?.data?.error || error.message || 'Onbekende fout';

      if (error?.response?.status === 401) {
        errorMessage = 'Sessie verlopen - je wordt doorgestuurd naar de login pagina...';
        this._dispatchUnauthorized();
      } else {
        this._dispatchCustomEvent('pdfParsingFailed', {
          filename: file.name,
          error: errorMessage
        });
      }

      return {
        success: false,
        filename: file.name,
        error: errorMessage
      };
    }
  }

  async uploadMultiplePdfs(files) {
    const results = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      // Dispatch progress event
      const progressEvent = new CustomEvent('pdfUploadProgress', {
        detail: {
          current: i + 1,
          total: files.length,
          filename: file.name
        }
      });
      this.dispatchEvent(progressEvent);

      const result = await this.uploadPdf(file);
      results.push(result);
    }

    // Dispatch completion event
    const completionEvent = new CustomEvent('pdfUploadCompleted', {
      detail: {
        results: results,
        successCount: results.filter(r => r.success).length,
        errorCount: results.filter(r => !r.success).length
      }
    });

    setTimeout(() => {
      this.dispatchEvent(completionEvent);
    }, 100);

    return results;
  }
}

export default PdfParsingService;
